import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { GovBrAccordion, GovBrTable } from 'components';
import { IconButton, Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { AGHUInfoDialog } from './AGHUInfoDialog';

export function SuccessAccordion({ data = [] }) {
  const { organizationList } = useNewConsentModalContext();
  const [aghuOpen, setAghuOpen] = useState(false);
  const [aghuInfo, setAghuInfo] = useState({});
  const header = [
    { display: 'CPF ou CNS', path: 'patient_id' },
    { display: 'ID do documento', path: 'local_id' },
    { display: 'Tipo do documento', path: 'model' },
    { display: 'Data do processamento', path: '@timestamp' },
    { display: 'Unidade hospitalar', path: 'organization_name' },
    { display: 'Resultado do processamento', path: 'status' },
  ];

  // Função para formatar data no padrão DD/MM/YYYY - HH:mm
  function formatDateTime(dateTime) {
    if (!dateTime) return '-';

    // Criar uma data a partir do timestamp
    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) return '-';

    // Ajustar para o fuso horário correto (adicionar 3 horas para corrigir o problema)
    const adjustedDate = new Date(date.getTime() + 3 * 60 * 60 * 1000);

    return adjustedDate
      .toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
      .replace(',', ' - ');
  }

  const dictTypeStatus = {
    SUCCESS: 'Sucesso',
    NETWORK_ERROR: 'Erro de rede',
    PATIENT_DEMOGRAPHICS_ERROR: 'Erro demográfico de paciente',
    PATIENT_IDENTIFIER_ERROR: 'Erro de identificador de paciente',
    SERVER_ERROR: 'Erro no servidor',
    VALIDATION_ERROR: 'Erro de validação',
  };

  const dictTypeModel = {
    PatientData: 'Cadastro de paciente',
    RACData: 'Registro de atendimento clínico',
    SAData: 'Sumário de alta',
    AttachmentModel: 'Documento assinado (atestados, prescrições, etc.)',
    ResultadoExameData: 'Resultado de exame',
  };

  const handleAghuOpen = (e) => {
    setAghuOpen(true);
    setAghuInfo(e);
  };

  const rows = data?.map((el) => ({
    ...el,
    model: dictTypeModel[el?.model],
    '@timestamp': formatDateTime(el['@timestamp']),
    statusValue: dictTypeStatus[el.status],
    status: (
      <div
        style={{
          marginLeft: '10px',
          display: 'flex',

          width: 'fit-content',
          alignItems: 'center',
        }}
      >
        {dictTypeStatus[el.status]}

        <Tooltip title="Integrações com AGHU">
          <IconButton
            onClick={
              () =>
                // eslint-disable-next-line implicit-arrow-linebreak
                handleAghuOpen({ localId: el?.local_id, cnes: el?.cnes })
              // eslint-disable-next-line react/jsx-curly-newline
            }
          >
            <Info />
          </IconButton>
        </Tooltip>
      </div>
    ),
    organization_name: organizationList?.find(
      (e) => e?.resource?.identifier?.[0]?.value === el?.cnes,
    )?.resource?.alias,
  }));

  const accordion = {
    title: 'Sucesso',
    content: <GovBrTable header={header} body={rows} />,
  };

  return (
    <>
      <GovBrAccordion
        name={accordion.title}
        content={accordion.content}
        total={rows.length}
        showMoreIndicator={data.length >= 1000}
      />

      {aghuOpen && (
        <AGHUInfoDialog
          open={aghuOpen}
          setModalOpen={setAghuOpen}
          data={aghuInfo}
        />
      )}
    </>
  );
}

SuccessAccordion.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

SuccessAccordion.defaultProps = {
  data: [],
};
